// extracted by mini-css-extract-plugin
export default {"subscribeModal":"src-modules-subscribe-modal-style__subscribeModal_56JXd"};